package org.example.garfend.sections


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.example.garfend.components.portfolioCard
import org.example.garfend.components.sectionTitle
import org.example.garfend.components.stringResource
import org.example.garfend.models.Portfolio
import org.example.garfend.models.Section
import org.example.garfend.util.Constants.SECTION_WIDTH
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun portfolioSection() {
    Box(
        modifier = Modifier
            .id(Section.Portfolio.id)
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        portfolioContent()
    }
}

@Composable
fun portfolioContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 90.percent else 92.percent),
        horizontalAlignment = Alignment.Start
    ) {
        sectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = 40.px),
            section = Section.Portfolio,
            eyebrow = stringResource("eyebrow_portfolio"),
            mainTitle = stringResource("main_title_portfolio"),
            alignment = Alignment.Start
        )
        portfolioCards()
    }
}

@Composable
fun portfolioCards() {

    SimpleGrid(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = 25.px)
            .styleModifier { property("gap", "30px")},
        numColumns = numColumns(base = 1, sm = 2, md = 3)
    ) {
        Portfolio.entries.forEachIndexed { index, portfolio ->
            portfolioCard(
                modifier = Modifier,
                portfolio = portfolio,
                appearDelayMs = index * 80
            )
        }
    }
}
